export default {
  Open: 0,
  Finished: 1,
  Skipped: 2,
  NietVanToepassing: 3,
  Hidden: 4
};
